import { render, staticRenderFns } from "./Vistorias.vue?vue&type=template&id=a478d768"
import script from "./Vistorias.vue?vue&type=script&lang=js"
export * from "./Vistorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports